import { FileSignature } from "lucide-react";
import { useFetch } from "@/hooks/useFetch";
import { money } from "@/lib/api";
import HelpTip from "@/components/HelpTip";

const when = (iso) => (iso ? new Date(iso).toLocaleDateString("en-CA", { month: "short", day: "numeric" }) : "");

// Client-facing: contract price, approved changes, current total. Never unit costs or markup.
export default function ContractCard({ projectId }) {
  const { data } = useFetch(`/projects/${projectId}/contract-summary`);
  if (!data?.has_contract) return null;
  return (
    <section className="rounded-2xl border bg-card p-6" data-testid="client-contract">
      <p className="eyebrow flex items-center gap-2"><FileSignature className="h-4 w-4" />Your contract price<HelpTip term="Contract Summary" /></p>
      <div className="mt-4 grid gap-4 sm:grid-cols-3">
        <div><p className="text-xs text-muted-foreground">Original price</p><p className="stat mt-1 text-xl" data-testid="contract-original">{money(data.original)}</p></div>
        <div><p className="text-xs text-muted-foreground">Approved changes</p><p className={`stat mt-1 text-xl ${data.changes < 0 ? "text-emerald-700" : ""}`} data-testid="contract-changes">{data.changes >= 0 ? "+" : "−"}{money(Math.abs(data.changes))}</p></div>
        <div><p className="text-xs text-muted-foreground">Current price</p><p className="stat mt-1 text-xl font-semibold" data-testid="contract-current">{money(data.current)}</p></div>
      </div>
      {data.approved.length > 0 && (
        <ul className="mt-4 divide-y text-sm" data-testid="contract-changes-list">
          {data.approved.map((c) => <li key={c.id} className="flex items-center justify-between gap-3 py-1.5"><span className="min-w-0 truncate">CO-{String(c.number).padStart(2, "0")} · {c.title}<span className="ml-2 text-xs text-muted-foreground">approved {when(c.decided_at)}</span></span><span className="stat shrink-0">{c.amount >= 0 ? "+" : "−"}{money(Math.abs(c.amount))}</span></li>)}
        </ul>
      )}
      <p className="mt-4 text-xs text-muted-foreground">
        {data.tax_rate ? `${money(data.current_total)} including ${data.tax_rate}% tax. ` : ""}
        {data.pending_count > 0 ? `${data.pending_count} change order${data.pending_count === 1 ? "" : "s"} (${money(data.pending_amount)}) awaiting your decision — not included until approved.` : "Only changes you've approved are included."}
      </p>
    </section>
  );
}
